import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    IconButton,
} from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialSelect from "../../../components/MaterialSelect";
import MaterialInput from "../../../components/MaterialInput";
import axios from "axios";
import { BASE_URL, deleteData, fetchDataById } from "../../Utils/Baseurl";

import { useSnackbar } from "../../../components/SnackbarProvider";
import DynamicTable from "../../../components/Dynamictabel/Dynamictabel";
import { useLoading } from "../../../context/loadingcontext";
import Swal from "sweetalert2";

const Module = () => {
    const { showSnackbar } = useSnackbar();
    const { setCirleLoading } = useLoading();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [moduleData, setModuleData] = useState({
        project: "",
        milestone: "",
        moduleName: "",
        moduleDescription: "",
        projectStatus: "unchecked",
        milestoneStatus: "unchecked",
        moduleNameStatus: "unchecked",
        moduleDescriptionStatus: "unchecked",
    });

    const [pages, setPages] = useState({
        view: false,
        edit: false,
        id: "",
    });

    const [projectData, setProjectData] = useState([]);
    const [milestoneData, setMilestoneData] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [editID, setEditID] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [filterProject, setFilterProject] = useState(null);
    const [filterMilestone, setFilterMilestone] = useState(null);
    const [filterMilestoneData, setFilterMilestoneData] = useState([]);
    const currentUser = sessionStorage.getItem("currentUser");

    useEffect(() => {
        fetchProjectData();
        fetchModules();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchProjectData = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const response = await axios.post(
                `${BASE_URL}api/getProject/`,
                {
                    user_id: currentUser,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setProjectData(response.data.data);
        } catch (error) {
            console.log(error, "error");
        }
    };

    const fetchModules = async (page = 1, projectId = filterProject?.value, milestoneId = filterMilestone?.value) => {
        setIsLoading(true);
        try {
            const token = sessionStorage.getItem("token");
            const response = await axios.get(`${BASE_URL}api/project_module/`, {
                params: {
                    page: page,
                    project_id: projectId || "",
                    milestone: milestoneId || "",
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setModuleList(response.data.data || []);
            setTotalRows(response.data.count || 0);
            setCurrentPage(page);
        } catch (error) {
            console.log(error, "error");
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMilestonesByProject = async (projectId) => {
        try {
            const token = sessionStorage.getItem("token");
            const response = await axios.get(`${BASE_URL}api/get_projectmilestone/`, {
                params: { project_id: projectId },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data?.status) {
                setMilestoneData(response.data?.data);
            } else {
                setMilestoneData([]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleProjectChange = (selectedOption) => {
        console.log(selectedOption,'selectedOptionll')
        setModuleData((prevData) => ({
            ...prevData,
            project: selectedOption,
            projectStatus: selectedOption ? "success" : "error",
            milestone: "", 
            milestoneStatus: "unchecked",
        }));
        if (selectedOption) {
            fetchMilestonesByProject(selectedOption.value);
        } else {
            setMilestoneData([]);
        }
    };

    const handleMilestoneChange = (selectedOption) => {
        setModuleData((prevData) => ({
            ...prevData,
            milestone: selectedOption,
            milestoneStatus: selectedOption ? "success" : "error",
        }));
    };

    const handleFilterProjectChange = async (selectedOption) => {
        setFilterProject(selectedOption);
        setFilterMilestone(null);
        if (selectedOption) {
            try {
                const token = sessionStorage.getItem("token");
                const response = await axios.get(`${BASE_URL}api/get_projectmilestone/`, {
                    params: { project_id: selectedOption.value },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data?.status) {
                    setFilterMilestoneData(response.data?.data);
                } else {
                    setFilterMilestoneData([]);
                }
            } catch (err) {
                console.log(err);
                setFilterMilestoneData([]);
            }
            fetchModules(1, selectedOption.value, null);
        } else {
            setFilterMilestoneData([]);
            fetchModules(1, null, null);
        }
    };

    const handleFilterMilestoneChange = (selectedOption) => {
        setFilterMilestone(selectedOption);
        fetchModules(1, filterProject?.value, selectedOption?.value);
    };

    const handleClearFilters = () => {
        setFilterProject(null);
        setFilterMilestone(null);
        setFilterMilestoneData([]);
        fetchModules(1, null, null);
    };

    const handleModuleChange = (e) => {
        const { name, value } = e.target;

        setModuleData((prevData) => {
            const updatedData = { ...prevData };
            const statusField = `${name}Status`;

            switch (name) {
                case "moduleName":
                    const nameRegex = /^[a-zA-Z0-9\s]*$/;
                    if (value.trim() === "" || !nameRegex.test(value)) {
                        updatedData[statusField] = "error";
                    } else {
                        updatedData[statusField] = "success";
                    }
                    updatedData[name] = value;
                    break;

                case "moduleDescription":
                    const descRegex = /^[\w\s!@#$%^&*()\-_=+[\]{};:'",.<>/?|\\`~]*$/;
                    if (value.trim() === "" || !descRegex.test(value)) {
                        updatedData[statusField] = "error";
                    } else {
                        updatedData[statusField] = "success";
                    }
                    updatedData[name] = value;
                    break;

                default:
                    break;
            }

            return updatedData;
        });
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
        setPages({
            view: false,
            edit: false,
            id: "",
        });
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setModuleData({
            project: "",
            milestone: "",
            moduleName: "",
            moduleDescription: "",
            projectStatus: "unchecked",
            milestoneStatus: "unchecked",
            moduleNameStatus: "unchecked",
            moduleDescriptionStatus: "unchecked",
        });
    };

    const handleSubmitModule = async () => {
        const { milestone, moduleName, moduleDescription } = moduleData;

        try {
            const data = {
                module_name: moduleName,
                description: moduleDescription,
                user_id: currentUser,
                milestone_id: milestone.value,
            };

            const token = sessionStorage.getItem("token");
            await axios.post(`${BASE_URL}api/project_module/`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            showSnackbar("Module added successfully", "success");
            setDialogOpen(false);
            setModuleData({
                project: "",
                milestone: "",
                moduleName: "",
                moduleDescription: "",
                projectStatus: "unchecked",
                milestoneStatus: "unchecked",
                moduleNameStatus: "unchecked",
                moduleDescriptionStatus: "unchecked",
            });
            fetchModules(currentPage);
        } catch (error) {
            console.error("Submit error:", error);
            showSnackbar("Failed to add the module", "error");
        }
    };

    const handleUpdateModule = async () => {
        const { milestone, moduleName, moduleDescription } = moduleData;

        try {
            const token = sessionStorage.getItem("token");
            await axios.put(
                `${BASE_URL}api/project_module/${editID}/`,
                {
                    module_name: moduleName,
                    description: moduleDescription,
                    user_id: currentUser,
                    milestone_id: milestone.value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            showSnackbar("Module updated successfully", "success");
            setDialogOpen(false);
            setModuleData({
                project: "",
                milestone: "",
                moduleName: "",
                moduleDescription: "",
                projectStatus: "unchecked",
                milestoneStatus: "unchecked",
                moduleNameStatus: "unchecked",
                moduleDescriptionStatus: "unchecked",
            });
            fetchModules(currentPage);
        } catch (error) {
            console.error("Update error:", error);
            showSnackbar("Failed to update the module", "error");
        } finally {
            setDialogOpen(false);
        }
    };

    const moduleTable = {
        columns: [
            {
                key: "projectName",
                header: "Project Name",
            },
            {
                key: "milestoneName",
                header: "Milestone Name",
            },
            {
                key: "moduleName",
                header: "Module Name",
            },
            { header: "ACTION", key: "action" },
        ],
        row: moduleList?.map((item) => ({
            id: item?.id ?? "-",
            projectName: item?.project_name
                ? item.project_name.replace(/_/g, " ")
                : "-",
            milestoneName: item?.milestone_name
                ? item.milestone_name.replace(/_/g, " ")
                : "-",
            moduleName: item?.module_name
                ? item.module_name.replace(/_/g, " ")
                : "-",
        })),
    };

    const editModule = async (row) => {
        handleDialogOpen();
        setCirleLoading(true);
        setPages({
            view: false,
            edit: true,
            id: row,
        });
        try {
            const response = await fetchDataById(`api/project_module/${row}/`);


            setEditID(response.data.id);
            if (response.status) {

                await fetchMilestonesByProject(response?.data?.project);

                setModuleData((prev) => ({
                    ...prev,
                    project: {
                        value: response?.data?.project,
                        label: response?.data?.project_name,
                    },
                    milestone: {
                        value: response?.data?.milestone,
                        label: response?.data?.milestone_name,
                    },
                    moduleName: response?.data?.module_name,
                    moduleDescription: response?.data?.description,
                    projectStatus: "success",
                    milestoneStatus: "success",
                    moduleNameStatus: "success",
                    moduleDescriptionStatus: "success",
                }));
            }
        } catch (error) {
            console.error("Error fetching module data:", error);
            showSnackbar("Failed to edit the module", "error");
        } finally {
            setCirleLoading(false);
        }
    };

    const moduleView = async (row) => {
        handleDialogOpen();
        setCirleLoading(true);
        setPages({
            view: true,
            edit: false,
            id: row,
        });
        try {
            const response = await fetchDataById(`api/project_module/${row}/`);

            if (response.status) {
                await fetchMilestonesByProject(response?.data?.project);
                setModuleData((prev) => ({
                    ...prev,
                    project: {
                        value: response?.data?.project,
                        label: response?.data?.project_name,
                    },
                    milestone: {
                        value: response?.data?.milestone,
                        label: response?.data?.milestone_name,
                    },
                    moduleName: response?.data?.module_name,
                    moduleDescription: response?.data?.module_description,
                    projectStatus: "success",
                    milestoneStatus: "success",
                    moduleNameStatus: "success",
                    moduleDescriptionStatus: "success",
                }));
            }
        } catch (error) {
            console.error("Error fetching module data:", error);
            showSnackbar("Failed to view the module", "error");
        } finally {
            setCirleLoading(false);
        }
    };

    const handleModuleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this module?",
            text: "This action is irreversible and cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });
        if (result.isConfirmed) {
            setCirleLoading(true);
            try {
                const response = await deleteData(`api/project_module/${id}/`);

                if (response.status) {
                    showSnackbar(response?.message, "success");
                } else {
                    showSnackbar(response?.message, "error");
                }
                fetchModules(currentPage);
            } catch (error) {
                showSnackbar("Failed to delete the module", "error");
            } finally {
                setCirleLoading(false);
            }
        }
    };

    const checkAllFields = () => {
        return (
            moduleData.projectStatus === "success" &&
            moduleData.milestoneStatus === "success" &&
            moduleData.moduleNameStatus === "success" &&
            moduleData.moduleDescriptionStatus === "success"
        );
    };

    return (
        <DashboardLayout>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                p={1}
                mb={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="bold" color="dark">
                        Module
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        You can view the module list here.
                    </MaterialTypography>
                </Stack>

                <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleDialogOpen}
                >
                    Add module
                </MaterialButton>
            </Stack>

            <Grid container spacing={2} sx={{ px: 1, mb: 3 }} alignItems="flex-end">
                <Grid item xs={12} sm={4} md={3}>
                    <Stack direction="column" spacing={1}>
                        <MaterialTypography variant="caption" color="text">
                            Project Name
                        </MaterialTypography>
                        <MaterialSelect
                            placeholder="Select Project"
                            value={filterProject}
                            onChange={handleFilterProjectChange}
                            options={projectData?.map((item) => ({
                                value: item.project_id,
                                label: item.project_name,
                            }))}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <Stack direction="column" spacing={1}>
                        <MaterialTypography variant="caption" color="text">
                            Milestone
                        </MaterialTypography>
                        <MaterialSelect
                            placeholder="Select Milestone"
                            value={filterMilestone}
                            onChange={handleFilterMilestoneChange}
                            options={filterMilestoneData?.map((item) => ({
                                value: item.id,
                                label: item.milestone_name,
                            }))}
                            isDisabled={!filterProject}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <IconButton
                        onClick={handleClearFilters}
                        sx={{
                            backgroundColor: '#fff1f2',
                            '&:hover': { backgroundColor: '#ffe4e6' },
                            p: 0.8,
                            mb: 0.2
                        }}
                    >
                        <FilterAltOffIcon sx={{ color: "#F63049", fontSize: '1.1rem' }} />
                    </IconButton>
                </Grid>
            </Grid>

            <DynamicTable
                columns={moduleTable?.columns}
                data={moduleTable?.row}
                onEdit={editModule}
                onDelete={handleModuleDelete}
                onView={moduleView}
                isLoading={isLoading}
                serverSide={true}
                totalRowsProp={totalRows}
                currentPageProp={currentPage}
                onPageChange={(page) => fetchModules(page)}
            />

            <Dialog
                open={dialogOpen}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleDialogClose();
                    }
                }}
                aria-labelledby="module-dialog-title"
                sx={{ "& .MuiDialog-paper": { width: "600px", maxWidth: "90%" } }}
            >
                <DialogTitle id="module-dialog-title">
                    {pages?.view
                        ? "View Module"
                        : pages?.edit
                            ? "Edit Module"
                            : "Add Module"}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack direction="column" spacing={1}>
                                <MaterialTypography variant="caption" color="text">
                                    Project Name<span style={{ color: "red" }}>*</span>
                                </MaterialTypography>
                                <MaterialSelect
                                    label="Project Name"
                                    name="project"
                                    value={moduleData.project}
                                    onChange={handleProjectChange}
                                    options={projectData?.map((item) => ({
                                        value: item.project_id,
                                        label: item.project_name,
                                    }))}
                                    error={moduleData.projectStatus === "error"}
                                    success={moduleData.projectStatus === "success"}
                                    isDisabled={pages.view === true}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack direction="column" spacing={1}>
                                <MaterialTypography variant="caption" color="text">
                                    Milestone<span style={{ color: "red" }}>*</span>
                                </MaterialTypography>
                                <MaterialSelect
                                    label="Milestone"
                                    name="milestone"
                                    value={moduleData.milestone}
                                    onChange={handleMilestoneChange}
                                    options={milestoneData?.map((item) => ({
                                        value: item.id,
                                        label: item.milestone_name,
                                    }))}
                                    error={moduleData.milestoneStatus === "error"}
                                    success={moduleData.milestoneStatus === "success"}
                                    isDisabled={pages.view === true || !moduleData.project}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Stack direction="column" spacing={1}>
                                <MaterialTypography variant="caption" color="text">
                                    Module Name<span style={{ color: "red" }}>*</span>
                                </MaterialTypography>
                                <MaterialInput
                                    label="Module Name"
                                    name="moduleName"
                                    value={moduleData.moduleName}
                                    onChange={handleModuleChange}
                                    error={moduleData.moduleNameStatus === "error"}
                                    success={moduleData.moduleNameStatus === "success"}
                                    disabled={pages.view === true}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Stack direction="column" spacing={1}>
                                <MaterialTypography variant="caption" color="text">
                                    Module Description<span style={{ color: "red" }}>*</span>
                                </MaterialTypography>
                                <MaterialInput
                                    label="Module Description"
                                    name="moduleDescription"
                                    multiline
                                    rows={3}
                                    value={moduleData.moduleDescription}
                                    onChange={handleModuleChange}
                                    error={moduleData.moduleDescriptionStatus === "error"}
                                    success={moduleData.moduleDescriptionStatus === "success"}
                                    disabled={pages.view === true}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        Cancel
                    </Button>
                    {!pages.view && (
                        <Button
                            onClick={pages.edit ? handleUpdateModule : handleSubmitModule}
                            color="dark"
                            variant="gradient"
                            disabled={!checkAllFields()}
                        >
                            {pages.edit ? "Update" : "Submit"}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
};

export default Module;
